"use client";

import { useState } from 'react';

export default function Home() {
  const [activeFeature, setActiveFeature] = useState(0);

  const features = [
    {
      icon: "diamond",
      title: "Instant Premium Website",
      desc: "We build you a stunning, high-converting personal website instantly. No agencies, no waiting. You just look like the top agent from day one.",
      link: "See An Example",
      path: "/emerging"
    },
    {
      icon: "auto_awesome",
      title: "Always-On Marketing",
      desc: "Your digital life runs on autopilot. We keep your online profiles perfectly updated and ensure you show up when vendors search for you.",
      link: "See How It Works",
      path: "/established"
    },
    {
      icon: "shield_person",
      title: "5-Star Reputation",
      desc: "Reviews make or break you. We help you collect more 5-star reviews from happy clients and make sure your offline excellence matches your online profile.",
      link: "Protect Your Name",
      path: "/established"
    },
    {
      icon: "domain",
      title: "Own Your Suburb",
      desc: "We secure the exact web domains your buyers and sellers are looking for, locking out your competition and bringing leads directly to you.",
      link: "Claim Your Area",
      path: "/established"
    }
  ];

  return (
    <main className="min-h-screen bg-background text-on-surface font-body selection:bg-primary selection:text-on-primary">
      {/* Top Navigation */}
      <nav className="fixed top-0 w-full z-50 bg-[#01132e]/80 backdrop-blur-xl shadow-[0_20px_40px_rgba(214,227,255,0.06)]">
        <div className="flex justify-between items-center px-12 py-6 max-w-[1920px] mx-auto">
          <div className="flex items-center gap-2">
            <img src="/sellwith_brand_blue_gold_transparent.png" alt="SellWith.nz" className="h-16" />
          </div>
          <div className="hidden md:flex gap-12 font-playfair tracking-widest uppercase text-sm">
            <a className="text-[#d4af37] border-b border-[#d4af37] pb-1 hover:opacity-100 transition-all duration-500" href="#">Portfolio</a>
            <a className="text-[#d6e3ff] opacity-80 hover:text-[#d4af37] hover:opacity-100 transition-all duration-500" href="#">Concierge</a>
            <a className="text-[#d6e3ff] opacity-80 hover:text-[#d4af37] hover:opacity-100 transition-all duration-500" href="#">Intelligence</a>
          </div>
          <button className="px-6 py-2 border border-primary text-primary font-['Manrope'] text-sm uppercase tracking-widest hover:bg-primary hover:text-on-primary transition-all duration-300 scale-95">
            Beta Portal
          </button>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
        <div className="absolute inset-0 z-0">
          <div className="absolute inset-0 bg-gradient-to-b from-surface/40 via-surface/60 to-surface z-10"></div>
          <img className="w-full h-full object-cover" alt="Cinematic wide shot of a multi-story glass luxury mansion at night" src="https://lh3.googleusercontent.com/aida-public/AB6AXuDQg_FUYMCbpv-ldulEZqlALJ7B_vkisWH6V4ukefDaqaEAeDPDJqWp06GIDFBZPTOe2P4xvSgVcXNgrpJb070FSQ8dattJvB61FQoKcF0LTBL8L1uqGbxA-QeWFM2_yvWL-re5jTo9GJABJwFNwbUeoz9xpqXaKnnpbFKsnRU6jCZAT_6UPf_jMHhie7txJ5jXLBwck-sBcghYlzSnJsYJeetv0v8NhmHhc3Q3F6cXLDfw3J8hIytvhx5rDk9_yPpPKfkvjAwJlu4n" />
        </div>
        <div className="relative z-20 text-center px-6 max-w-5xl mx-auto mt-12">
          <img alt="SellWith.nz Gold Logo" className="w-[80%] max-w-[600px] h-auto object-contain mx-auto mb-8" src="/sellwith_brand_gold_front_transparent.png" />
          <h1 className="font-playfair text-5xl md:text-7xl lg:text-8xl text-on-surface mb-8 tracking-tight drop-shadow-[0_4px_12px_rgba(0,0,0,0.5)] leading-none">
            Your Digital Identity,<br/>
            <span className="italic font-light">Hand-Crafted for the Elite.</span>
          </h1>
          <p className="font-['Manrope'] text-xl md:text-2xl text-secondary max-w-3xl mx-auto mb-12 font-light leading-relaxed drop-shadow-md">
            Bespoke automation for the top 1% of real estate professionals. Elevate your personal brand with intelligent precision.
          </p>
          <div className="flex flex-col md:flex-row gap-6 justify-center items-center">
            <div className="w-full max-w-md bg-[rgba(36,53,81,0.4)] backdrop-blur-[20px] p-1 rounded-lg flex items-center shadow-lg border border-white/5">
              <input className="bg-transparent border-none text-on-surface focus:ring-0 w-full px-6 py-4 font-['Manrope'] text-lg outline-none placeholder:text-on-surface-variant/70" placeholder="Enter your professional email" type="email" />
              <button className="gold-gradient text-on-primary px-8 py-4 font-['Manrope'] font-bold uppercase tracking-wider rounded-lg hover:brightness-110 transition-all flex-shrink-0">
                Access
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Features Carousel */}
      <section className="py-32 px-6 md:px-12 bg-surface relative z-20">
        <div className="max-w-[1400px] mx-auto">
          <div className="mb-16 flex flex-col items-center text-center">
            <label className="text-primary font-['Manrope'] text-sm uppercase tracking-[0.2em] block mb-4">How It Works</label>
            <h2 className="font-playfair text-4xl md:text-5xl text-on-surface leading-tight">Simple. Automatic. Proven.</h2>
          </div>
          
          <div className="relative bg-surface-container-highest border border-primary/20 p-8 md:p-12 min-h-[450px] max-w-5xl mx-auto flex items-center justify-center overflow-hidden group transition-all duration-700">
            {features.map((feature, idx) => (
              <div 
                key={idx}
                className={`absolute inset-0 p-8 md:p-16 flex flex-col justify-center items-center text-center transition-all duration-700 transform ${
                  activeFeature === idx ? 'opacity-100 translate-y-0 translate-x-0 z-10' : 'opacity-0 translate-x-24 z-0 pointer-events-none'
                }`}
              >
                 <span className="material-symbols-outlined text-primary text-6xl md:text-8xl mb-6" style={{ fontVariationSettings: "'FILL' 0" }}>{feature.icon}</span>
                 <h3 className="font-playfair text-4xl md:text-6xl text-on-surface mb-6">{feature.title}</h3>
                 <p className="text-on-surface-variant text-xl md:text-2xl leading-relaxed mb-10 font-light font-['Manrope'] max-w-4xl mx-auto">{feature.desc}</p>
                 <a href={feature.path} className="text-sm font-['Manrope'] uppercase tracking-[0.2em] text-primary hover:text-white transition-colors cursor-pointer border-b border-primary/30 hover:border-white pb-2">{feature.link} →</a>
              </div>
            ))}
            
            {/* Navigation Dots */}
            <div className="absolute bottom-8 left-0 right-0 flex justify-center gap-4 z-20">
              {features.map((_, idx) => (
                <button 
                  key={idx}
                  onClick={() => setActiveFeature(idx)}
                  className={`w-12 h-1 transition-all duration-300 ${activeFeature === idx ? 'bg-primary' : 'bg-outline-variant/30 hover:bg-outline-variant'}`}
                  aria-label={`Go to slide ${idx + 1}`}
                />
              ))}
            </div>

            {/* Navigation Arrows */}
            <button 
              onClick={() => setActiveFeature(prev => prev === 0 ? features.length - 1 : prev - 1)}
              className="absolute left-6 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center rounded-full border border-primary/20 text-primary hover:bg-primary/10 transition-colors z-20 hidden md:flex"
            >
              <span className="material-symbols-outlined">chevron_left</span>
            </button>
            <button 
              onClick={() => setActiveFeature(prev => prev === features.length - 1 ? 0 : prev + 1)}
              className="absolute right-6 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center rounded-full border border-primary/20 text-primary hover:bg-primary/10 transition-colors z-20 hidden md:flex"
            >
              <span className="material-symbols-outlined">chevron_right</span>
            </button>
          </div>
        </div>
      </section>

      {/* Aesthetic Break / Showcase */}
      <section className="py-24 bg-surface-container-lowest overflow-hidden">
        <div className="max-w-[1400px] mx-auto px-12">
          <div className="flex flex-col md:flex-row items-center gap-20">
            <div className="w-full md:w-1/2 relative">
              <div className="absolute -top-12 -left-12 w-64 h-64 bg-primary/10 rounded-full blur-3xl"></div>
              <div className="relative bg-[rgba(36,53,81,0.4)] backdrop-blur-[20px] p-4 rotate-3 border border-white/5">
                <img className="w-full aspect-square object-cover grayscale hover:grayscale-0 transition-all duration-1000" alt="Interior of a ultra-modern minimalist luxury penthouse" src="https://lh3.googleusercontent.com/aida-public/AB6AXuD78_M_hA7zAJNfPR3biBC9xVhhl58LR7TES1CExieLAd7roXbgOynUqMlndo-c4ZRJy2ZIh3pq1oJXffSaD6_p9r5RqSWZkLIWnckW11AC04N7RVHMLDiY8_cTZbBvLvF6FPkQLLf5zQ6qCGGyvyGqWskQThueu_kuV4_szxjqTFS7Gz8tAG2FZtjKd-jSJ-VvnVMYbvN4Jba48lg3OCcpZw5KAaKPV4FXbQ2TMHLe76-K3CCTqbAgr70_NJMkCGzBezD2nLd6gaSd" />
              </div>
              <div className="absolute -bottom-10 -right-10 bg-primary p-12 hidden lg:block">
                <span className="font-playfair text-on-primary text-4xl italic">99th Percentile</span>
              </div>
            </div>
            <div className="w-full md:w-1/2">
              <h2 className="font-playfair text-4xl md:text-5xl text-on-surface mb-8 leading-tight italic">Exclusivity by Design.</h2>
              <p className="text-on-surface-variant text-lg mb-12 leading-relaxed font-light font-['Manrope']">
                We don't build websites. We curate digital experiences that serve as the silent concierge to your success. Each line of code is as intentional as the materials in a master-built estate.
              </p>
              <ul className="space-y-6 font-['Manrope']">
                <li className="flex items-center gap-4 text-on-surface">
                  <span className="material-symbols-outlined text-primary">check_circle</span>
                  <span className="font-medium tracking-wide">Zero-touch automation workflows</span>
                </li>
                <li className="flex items-center gap-4 text-on-surface">
                  <span className="material-symbols-outlined text-primary">check_circle</span>
                  <span className="font-medium tracking-wide">Ultra-low latency global hosting</span>
                </li>
                <li className="flex items-center gap-4 text-on-surface">
                  <span className="material-symbols-outlined text-primary">check_circle</span>
                  <span className="font-medium tracking-wide">White-glove concierge support</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-32 bg-surface text-center px-6">
        <div className="max-w-3xl mx-auto bg-[rgba(36,53,81,0.4)] backdrop-blur-[20px] p-20 border border-primary/10 relative overflow-hidden">
          <div className="absolute top-0 right-0 p-4 opacity-10">
            <span className="material-symbols-outlined text-[120px]">architecture</span>
          </div>
          <h2 className="font-playfair text-4xl md:text-5xl text-on-surface mb-6">Ready to Elevate Your Brand?</h2>
          <p className="text-on-surface-variant text-xl mb-12 font-light font-['Manrope']">Join the fastest growing group of elite real estate professionals. It just works.</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="gold-gradient text-on-primary px-12 py-5 font-['Manrope'] font-bold uppercase tracking-[0.2em] hover:scale-105 transition-transform duration-300">
              Get Started
            </button>
            <button className="bg-transparent border border-primary/30 text-primary px-12 py-5 font-['Manrope'] font-bold uppercase tracking-[0.2em] hover:bg-primary/5 transition-all">
              Learn More
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#000e25] w-full py-24 border-t border-white/5">
        <div className="flex flex-col items-center gap-12 px-8 w-full max-w-7xl mx-auto">
          <img src="/sellwith_brand_blue_gold_transparent.png" alt="SellWith.nz" className="h-16" />
          <div className="flex flex-wrap justify-center gap-12 font-['Manrope'] text-sm tracking-widest uppercase">
            <a className="text-[#d6e3ff]/60 hover:text-[#d4af37] transition-colors duration-300" href="#">Concierge</a>
            <a className="text-[#d6e3ff]/60 hover:text-[#d4af37] transition-colors duration-300" href="#">Intelligence</a>
            <a className="text-[#d6e3ff]/60 hover:text-[#d4af37] transition-colors duration-300" href="#">Legal</a>
          </div>
          <div className="w-full h-px bg-white/5"></div>
          <div className="flex flex-col items-center gap-4 text-center">
            <p className="text-[#d6e3ff]/60 font-['Manrope'] text-sm tracking-widest opacity-80 hover:opacity-100 transition-opacity">
              © 2026 SellWith.nz Digital Atelier. All Rights Reserved.
            </p>
            <div className="flex gap-6 mt-4">
              <span className="material-symbols-outlined text-[#d4af37] cursor-pointer hover:scale-110 transition-transform">share</span>
              <span className="material-symbols-outlined text-[#d4af37] cursor-pointer hover:scale-110 transition-transform">contact_page</span>
              <span className="material-symbols-outlined text-[#d4af37] cursor-pointer hover:scale-110 transition-transform">shield</span>
            </div>
            <p className="text-[#d6e3ff]/60 font-['Manrope'] text-[10px] tracking-widest opacity-40 hover:opacity-100 transition-opacity mt-2 uppercase">
              Created by Mike Pearce
            </p>
          </div>
        </div>
      </footer>
    </main>
  );
}

